import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=a6435686&scoped=true&"
import script from "./JImageUpload.vue?vue&type=script&lang=js&"
export * from "./JImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./JImageUpload.vue?vue&type=style&index=0&id=a6435686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6435686",
  null
  
)

export default component.exports